import React from 'react';
import PropTypes from 'prop-types';
import css from './Alert.module.scss';
import Button from '../Button/Button';
import AlertTriangle from "../Icons/AlertTriangle";
import Book02 from "../Icons/Book02";
import InformationCircleContained from '../Icons/InformationCircleContained';
import ChevronRight from '../Icons/ChevronRight';

const VARIANT_ICONS = {
  info: InformationCircleContained,
  tip: Book02,
  success: InformationCircleContained,
  warning: AlertTriangle,
  danger: AlertTriangle,
  overlay: InformationCircleContained,
};

const Alert = ({
  variant = 'info',
  title,
  icon,
  actionText,
  onActionClick,
  className = '',
  textClassName,
  illustration,
  style = {},
  children,
}) => {
  const DefaultIcon = VARIANT_ICONS[variant];

  return (
    <div
      className={`${css.alert} ${css[variant]} ${className}`}
      style={style}
    >
      <div className={css.content}>
        <div className={css.icon}>
          {icon || <DefaultIcon />}
        </div>
        <div className={css.textWrapper}>
          {title && <span className={css.title}>{title}</span>}
          {children &&
            <span className={`${textClassName} ${css.text}`}>
              {children}
            </span>
          }
        </div>
      </div>
      {actionText && onActionClick &&
        <Button
          variant="link"
          onClick={onActionClick}
          className={css.button}
          icon={<ChevronRight />}
          iconPosition="right"
        >
          {actionText}
        </Button>
      }
      {illustration &&
        <div className={css.illustration}>
          {illustration}
        </div>
      }
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf([
    'info',
    'warning',
    'success',
    'danger',
    'tip',
    'overlay'
  ]),
  title: PropTypes.string,
  icon: PropTypes.node,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  actionText: PropTypes.string,
  onActionClick: PropTypes.func,
  className: PropTypes.string,
};

export default Alert;
